export default __webpack_public_path__ + "8f7ee4e.png";